export const EMPLOYER_OPTIONAL_OCCUPATIONS = [
    'Business Owner',
    'Homemaker',
    'Housewife',
    'Other Occupation',
    'Retired',
    'Self employed',
    'Stay-at-Home Dad',
    'Stay-at-Home Mom',
    'Stay-at-Home Parent',
    'Student',
];
